import BackButton from '../../components/Button/IconButton/BackButton';
import ImageButton from '../../components/Button/ImageButton/ImageButton';
import HOT_DOG_BUNS from '../../assets/images/landing_page/hot_dog_buns.png';
import HOT_DOG_BUNS_OPEN from '../../assets/images/landing_page/hot_dog_buns_open.png';
import LAUNDRY_BASKET from '../../assets/images/landing_page/laundry_basket.png';
import LAUNDRY_BASKET_WITH_SOCK from '../../assets/images/landing_page/laundry_with_sock.png';
import PHONE_OFF from '../../assets/images/landing_page/phone_off.png';
import PHONE_ON from '../../assets/images/landing_page/phone_on.png';
import { GAME_FIRST_INITIALIZED_KEY, GameState } from '../game_state_defs';
import DialogueBox from '../../components/DialogueBox/DialogueBox';

import './landing-page.css';

interface LandingPageProps {
    goToMenuCb: () => void;
    goToGame: (newGameState: GameState) => void;
    dialogue: string[];
    setDialogueCb: (newDialogue: string[]) => void;
    fadeOut: boolean;
}

function LandingPage(props: LandingPageProps) {
    const { goToMenuCb, goToGame, dialogue, setDialogueCb, fadeOut } = props;

    return (
        <div className={'landing-page' + (fadeOut ? ' fade-out' : '')}>
            <BackButton onClick={goToMenuCb} />
            <div className="phone-image">
                <ImageButton
                    imageSrc={PHONE_OFF}
                    alt="Phone"
                    onClick={() => goToGame(GameState.PHONE_GAME)}
                    onHoverImageSrc={PHONE_ON}
                    width="3.125vw"
                />
            </div>
            <div className="hot-dog-buns-image">
                <ImageButton
                    imageSrc={HOT_DOG_BUNS}
                    alt="Hot dog buns"
                    onClick={() => goToGame(GameState.HOT_DOG_GAME)}
                    onHoverImageSrc={HOT_DOG_BUNS_OPEN}
                    width="4.427vw"
                />
            </div>
            <div className="laundry-basket-image">
                <ImageButton
                    imageSrc={LAUNDRY_BASKET}
                    alt="Laundry basket"
                    onClick={() => goToGame(GameState.LAUNDRY_GAME)}
                    onHoverImageSrc={LAUNDRY_BASKET_WITH_SOCK}
                    width="12.5vw"
                />
            </div>
            {window.localStorage.getItem(GAME_FIRST_INITIALIZED_KEY) ===
                'true' && (
                <DialogueBox
                    text={["Ugh... I don't want to do anything today..."]}
                    afterDialogueCb={() => {
                        window.localStorage.setItem(
                            GAME_FIRST_INITIALIZED_KEY,
                            'false'
                        );
                    }}
                />
            )}
            {dialogue.length > 0 && (
                <DialogueBox
                    text={dialogue}
                    afterDialogueCb={() => {
                        setDialogueCb([]);
                    }}
                />
            )}
        </div>
    );
}

export default LandingPage;
